<template>
<footer class="footer row">
    <div class="container my-2 my-md-4 px-0">
        <div class="row mx-0 justify-content-between align-items-center">
            <div class="ftco-footer-widget">
                <a href="https://minimumcrm.com" class="float-md-left">
                    <img src="../assets/logo-footer.png" class="img-fluid"/>
                </a>
                <div class="float-md-left text-white ml-md-4 mt-2">
                    <span>{{$ml.get('ALL_RIGHT_RESERVED')}}</span>
                </div>
            </div>
            <div>
                <div class="float-right footer-list">
                    <a href="#" class="asap" target="_blank" data-toggle="modal" data-target="#kullanim-kosullari" data-backdrop="static">{{$ml.get('TERMS_OF_SERVICE')}}</a>
                    <a href="#" class="asap" target="_blank" data-toggle="modal" data-target="#gizlilik-politikasi" data-backdrop="static">{{$ml.get('PRIVACY_POLICY')}}</a>
                    <span @click="changeLang('tr');" v-if="$ml.current!=='tr'">TR<img src="../assets/tr.png"/></span>
                    <span @click="changeLang('en');" v-else>EN<img src="../assets/en.png"/></span>
                </div>
            </div>
        </div>
    </div>
</footer>
</template>

<script>
    import axios from 'axios'
    import { mapState } from 'vuex'
    
    export default {
        name: 'Footer',
        data () {
            return {
                active:"",
                isHidden:true,
                name:'',
                permissionsId:"",
                someName:""
            }
        },
        methods: {
            changeLang(val){
                this.$ml.change(val);
            }
        },
    }
</script>
<style scoped>

.footer {
    color: #FFF;
    background-color: #1174bf;
    position: fixed;
    bottom: 0;
    width: 100%;
    font-size: 12px;
}
@media (max-width:768px){
    .ftco-footer-widget {
        text-align:center;
        margin: 0 auto;
    }
    .ftco-footer-widget+div{
        text-align: center;
        width: 100%;
    }
    .footer-list{
        text-align: center !important;
    }
}
.footer-list{
    width: 100%;
    text-align: right;
    color: #FFF;
}
.footer-list a {
    color: #FFF;
    display:inline-block;
    padding: 0px 15px;
}

.footer-list span{
    color: #FFF;
    cursor: pointer;
}

.footer-list span img {
	margin-left: 5px;
    width: 25px;
}
</style>